import { fetchLocalStock } from './api';
import { isTicketNetworkEventListing } from './listingEventDate';

/**
 * A `listings.show` response with the order engine's stock when it owns the listing's stock.
 * Local holds are not written back to Sharetribe, so its count is stale for those listings:
 * sold out is our 0 (listing stays open), and a decline or expiry makes it buyable again.
 * TN event listings never have local stock. Any failure keeps the response as it was.
 */
export const withLocalStock = response => {
  const listing = response?.data?.data;
  if (
    typeof window === 'undefined' ||
    listing?.type !== 'listing' ||
    !listing.id?.uuid ||
    isTicketNetworkEventListing(listing.attributes?.publicData)
  ) {
    return Promise.resolve(response);
  }
  return Promise.resolve()
    .then(() => fetchLocalStock(listing.id.uuid))
    .then(local => {
      if (!Number.isInteger(local?.quantity)) return response;
      const stockId = listing.relationships?.currentStock?.data?.id || listing.id;
      const others = (response.data.included || []).filter(
        e => !(e.type === 'stock' && e.id?.uuid === stockId.uuid)
      );
      return {
        ...response,
        data: {
          ...response.data,
          data: {
            ...listing,
            relationships: {
              ...listing.relationships,
              currentStock: { data: { id: stockId, type: 'stock' } },
            },
          },
          included: [...others, { id: stockId, type: 'stock', attributes: { quantity: local.quantity } }],
        },
      };
    })
    .catch(() => response);
};
